/* Belle Femme product-page helpers: sticky ATC, review jump, AJAX "add" for routine cards. */
(function () {
  if (window.__bfPdpInit) return;
  window.__bfPdpInit = true;

  function mainButton() {
    return document.querySelector('product-info product-form .product-form__submit, .product__info-container .product-form__submit');
  }

  // Sticky bar
  function initSticky() {
    var bar = document.querySelector('[data-bf-sticky]');
    var btn = mainButton();
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('bf-sticky-on', past);
    });
    io.observe(btn);
    bar.querySelector('[data-bf-sticky-btn]').addEventListener('click', function () {
      var b = mainButton();
      if (b && !b.disabled) b.click();
    });
  }

  // "★ 5.0 · 20 reviews" → scroll to the review app block
  function initReviewJump() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bf-scroll-reviews]');
      if (!a) return;
      var target = document.querySelector('#bf-reviews, [id*="air_product_reviews_app_block_review_list"], .shopify-app-block[id*="review"]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Routine/bundle cards: add via AJAX and open Dawn's cart drawer when present
  function initRoutineForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-bf-routine-form]');
      if (!form) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || !window.routes) return; // normal post → /cart
      e.preventDefault();
      var btn = form.querySelector('button');
      btn.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { form.submit(); return; }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () { form.submit(); })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  function init() { initSticky(); initReviewJump(); initRoutineForms(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
